

import React, { useState, useRef } from 'react';
import ProcessReport from './ProcessReport';
import ChartContainer from './ChartContainer';

  const AutomationROI = () => {

  
  return (
    <div>
    {/* <ChartContainer/> */}

    <ProcessReport/>
    </div>
  )
  
  };

  
  export default AutomationROI;